import { ref } from "vue";

export function useForm() {
    const submitted = ref(false);

    function error(errors: any, field: string) {
        return errors[field][0];
    }

    function hasError(errors: any, fields: string | string[]) {
        if (!Array.isArray(fields)) {
            fields = [fields];
        }

        for (const field of fields) {
            if (Object.prototype.hasOwnProperty.call(errors, field)) {
                return true;
            }
        }

        return false;
    }

    function hasErrorStartingWith(errors: any, prefix: string) {
        for (const field in errors) {
            if (
                Object.prototype.hasOwnProperty.call(errors, field) &&
                field.startsWith(prefix)
            ) {
                return true;
            }
        }
    }

    function oldInput(old: any, field: string) {
        return Object.prototype.hasOwnProperty.call(old, field)
            ? old[field]
            : null;
    }

    function onSubmit(form: any) {
        if (!submitted.value) {
            submitted.value = true;
            form.submit();
        }
    }

    return {
        error,
        hasError,
        hasErrorStartingWith,
        oldInput,
        onSubmit,
        submitted,
    };
}
